import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('LanguageTranslationMissingKeysResponse')
export class LanguageTranslationMissingKeysResponse {

  @JsonProperty('results', [String])
  results: string[] = [];
}
